import moment from "moment";

export const formatPrice = (
  amount: number,
  locale = "en-GB",
  currency = "EUR"
) => {
  if (isNaN(amount)) return "";

  const price = amount / 100;
  if (currency === "EUR" && locale.includes("en")) {
    const numberFormatted = new Intl.NumberFormat(locale, {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);

    return `${numberFormatted} €`;
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(price);
};

export const formatDateAsDuration = (ts: number): string => {
  const now = moment();
  const future = moment.unix(ts);
  const duration = moment.duration(future.diff(now));

  const months = Math.round(duration.asMonths());
  if (months >= 1) return `${months} mo`;

  const days = Math.round(duration.asDays());
  if (days >= 1) return `${days} d`;

  const hours = Math.round(duration.asHours());
  if (hours >= 1) return `${hours} h`;

  const minutes = Math.round(duration.asMinutes());
  if (minutes >= 1) return `${minutes} min`;

  return "now";
};
